/* unplugin-vue-components disabled */import { render } from "./SupPoolHistory.vue?vue&type=template&id=6f54cc66"
import script from "./SupPoolHistory.vue?vue&type=script&lang=js"
export * from "./SupPoolHistory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__